import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter, Route } from "react-router-dom";

import BaseView from "app/ui/components/BaseView";
import { store, persistor } from "./store";

// Define the Root element
const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <div>
        <BrowserRouter>
          <Route path="/portal2" component={BaseView} />
        </BrowserRouter>
      </div>
    </PersistGate>
  </Provider>
);

export default App;
